import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { RouteErrorFallback } from '@/components/route-error-fallback';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChangePasswordForm } from '@/features/account/components/change-password-form';
import { useChangePasswordMutation } from '@/features/account/hooks/use-change-password-mutation';
import { sessionQueryOptions } from '@/features/auth';

export const Route = createFileRoute('/_authenticated/account')({
	errorComponent: (props) => <RouteErrorFallback {...props} fallbackMessageKey='account_error_load' />,
	component: AccountRoute,
});

function AccountRoute() {
	const { t } = useTranslation();
	// Ensured by the _authenticated layout's beforeLoad — resolves from cache.
	const { data: session } = useSuspenseQuery(sessionQueryOptions);
	const changePasswordMutation = useChangePasswordMutation();

	return (
		<Card>
			<CardHeader>
				<CardTitle>{t('account_password_title')}</CardTitle>
				<CardDescription>{t('account_password_description', { email: session.user.email })}</CardDescription>
			</CardHeader>

			<CardContent>
				<ChangePasswordForm
					isSubmitting={changePasswordMutation.isPending}
					onSubmit={async (values) => {
						await changePasswordMutation.mutateAsync(values);
					}}
				/>
			</CardContent>
		</Card>
	);
}
